import React from "react";
import {
  WhmBox,
  WhmTypography,
  WhmCheckbox,
  WhmStack,
} from "@securitize/reactjs-whm";
import type { ReportSection } from "../../../data/types/portfolio-statement/portfolio-statement";
import { translationKeys } from "../../../hooks/useTranslation";
import { Translate } from "../../shared/translation";

interface IncludedSectionsPanelProps {
  sections: ReportSection[];
  selectedSectionIds: Set<string>;
  onToggleSection: (sectionId: string) => void;
}

export const IncludedSectionsPanel: React.FC<IncludedSectionsPanelProps> = ({
  sections,
  selectedSectionIds,
  onToggleSection,
}) => {
  return (
    <WhmBox sx={{ mb: 3 }}>
      <WhmTypography variant="subtitle1" fontWeight={700} sx={{ mb: 0.5 }}>
        <Translate
          translationKey={
            translationKeys.PORTFOLIO_STATEMENT_INCLUDED_SECTIONS_TITLE
          }
        />
      </WhmTypography>

      <WhmTypography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        <Translate
          translationKey={
            translationKeys.PORTFOLIO_STATEMENT_INCLUDED_SECTIONS_SUBTITLE
          }
        />
      </WhmTypography>

      {sections.map((section) => (
        <React.Fragment key={section.id}>
          <WhmStack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{
              py: 1.5,
              cursor: "pointer",
              "&:hover": { backgroundColor: "action.hover" },
            }}
            onClick={() => onToggleSection(section.id)}
          >
            <WhmTypography variant="body2">{section.label}</WhmTypography>
            <WhmCheckbox
              checked={selectedSectionIds.has(section.id)}
              onChange={() => onToggleSection(section.id)}
              onClick={(e) => e.stopPropagation()}
              inputProps={{
                "aria-label": `Include ${section.label}`,
              }}
              size="small"
            />
          </WhmStack>
        </React.Fragment>
      ))}
    </WhmBox>
  );
};
